import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import RouteManager from "../../managers/RouteManager";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import { fetchLocationList, selectLocationList } from "../../Redux/Slices/LocationListSlice";
import Utility, { deepClone } from "../../utility/Utility";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import {
  Toggle,
  INPUT_VIEW_DIRECTION,
  DKInput,
  DKButton,
  showToast,
  TOAST_TYPE,
} from "deskera-ui-library";
import {
  getLocationRowData,
  parseVisibleColumnConfig,
} from "../configs/config";
import AddEditLocation from "./AddLocation";
import { INPUT_TYPE, LOCATION } from "../../constants/Constant";
import TenantManager from "../../managers/TenantManager";
import LocationListService from "../../services/LocationListService";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

const initialState = {
  columnData: [],
  rowData: [],
  originalData: [],
  filter: [],
};

const ManageLocationList = (props) => {

    const [locationsList, setLocationsList] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(1);
    const [showAddEditPopup, setShowAddEditPopup] = useState(false);
    const [isEdit, setEditFlag] = useState(false);
    const [editData, setEditData] = useState({});
    const [trackLocation, setTrackLocation] = useState(false);
    const [locationLabel, setLocationLabel] = useState("");
    const [canValidate, setCanValidate] = useState(false);
    const [tenantDetails, setTenantDetails] = useState(TenantManager.getTenantDetails());
    const [locationData, setLocationData] = useState({});
    const [isListViewEnabled, setListViewEnabled] = useState(false);
    const [count, setCount] = useState(0);
    const [isTrackLocationApiEnabled, setTrackLocationApiValue] = useState(false);
    const [reload, setReload] = useState(false);
    const dispatch = useDispatch();
    const locationsDetails = useSelector(selectLocationList);


     useEffect(() => {
       RouteManager.setPresenter({ props });
       const additionalSettings = tenantDetails
         ? tenantDetails.additionalSettings
         : "";
       const locationSettings = additionalSettings ? additionalSettings?.['LOCATION'] : {};
       const trackLocation = locationSettings?.trackLocation || false;
       const locationLabel = locationSettings?.locationLabel || "";
       setTrackLocation(trackLocation);
       setLocationLabel(locationLabel);
       setLocationData(locationSettings);
       if (trackLocation && !Utility.isEmpty(locationLabel)) {
        setListViewEnabled(true);
        setTrackLocationApiValue(true);
        loadLocationList();
       };
     }, []);

     useEffect(() => {
       if (!Utility.isEmpty(locationsDetails)) {
         const functionConfig = getFunctionConfig();
         const rowData = getLocationRowData(locationsDetails, functionConfig);
         let employeeColumn = parseVisibleColumnConfig(
           TableManger.getTableColumns(TABLES.PEOPLE_LOCATION_LIST)
         );
         const data = {
           columnData: deepClone(employeeColumn),
           rowData: rowData,
           filter: [],
           originalData: rowData,
         };
         setLocationsList(data);
       } else {
         let employeeColumn = parseVisibleColumnConfig(
           TableManger.getTableColumns(TABLES.PEOPLE_LOCATION_LIST)
         );
         const data = {
           columnData: deepClone(employeeColumn),
           rowData: locationsList["rowData"],
           filter: [],
           originalData: locationsList["rowData"],
         };
         setLocationsList(data);
       }
     }, [locationsDetails,reload]);

     const loadLocationList = async () => {
         try {
           await dispatch(fetchLocationList());
         } catch (err) {
           console.error("Error loading locations: ", err);
         }
     };

     const onDeleteLocation = () => {

     }

     const onRowEdit = (data) => {
      console.log(data);
      setEditFlag(true);
      setEditData(data?.rowData);
      setShowAddEditPopup(true);
     }

     const getFunctionConfig = () => {
       let config = {
         editRow: onRowEdit,
       };
       return config;
     }

     const onCreateNew = () => {
        setEditData({});
        setEditFlag(false);
        setShowAddEditPopup(true);
     }

     const onClose = () => {
       setShowAddEditPopup(false);
     };

     const enableDisableManageLocation = (value) => {
       setTrackLocation(!trackLocation);
         const params = {
           additionalSettings: {
             LOCATION: {
               trackLocation: !trackLocation,
               locationLabel: locationLabel,
               locationCFId: locationData.locationCFId,
             },
           },
         };
         saveTenantSettings(params);
     }

     const getLocationLabel = (value) => {
      setLocationLabel(value)
     }

     const saveTenantSettings = (params) => {
      LocationListService.saveLocationSettings(params).then(
        (res) => {
          if (res) {
            const additionalSettings = res
              ? res.additionalSettings
              : "";
            const locationSettings = additionalSettings
              ? additionalSettings?.["LOCATION"]
              : {};
            const trackLocation = locationSettings?.trackLocation || false;
            setLocationData(locationSettings);
            setTrackLocationApiValue(trackLocation);
            TenantManager.setTenantDeatils(res);
            if (trackLocation) {
              loadLocationList();
            }
            showToast(
              `Location tracking ${
                trackLocation ? "enabled" : "disabled"
              } successfully`, TOAST_TYPE.SUCCESS
            );
          }
        },
        (error) => {
          showToast(
            "Some Unknown Error Occurred at Server. Please Try Again!",
            TOAST_TYPE.FAILURE
          );
        }
      );
     }

     const onLocationSettingsSave = () => {
       if(trackLocation && Utility.isEmpty(locationLabel)) {
         setCanValidate(true);
        return
       }
       const params = {
         additionalSettings: {
           LOCATION: {
             trackLocation: trackLocation,
             locationLabel: locationLabel,
             locationCFId: locationData.locationCFId,
           },
         },
       };
       saveTenantSettings(params);

     }

     const getLabelField = () => {
       return (
         <div style={{ flex: "0 0 50%", maxWidth: "50%" }}>
           <div className="row pb-l p-h-l position-relative">
             <DKInput
               title={"Location Label"}
               type={INPUT_TYPE.DROPDOWN}
               direction={INPUT_VIEW_DIRECTION.VERTICAL}
               dropdownConfig={{
                 allowSearch: true,
                 data: LOCATION,
                 renderer: (i, item) => item,
                 //  onSelect: (i, value) => {
                 //    updateValue(state, index, value);
                 //  },
               }}
               formatter={(obj) => {
                 /** How to render a selected option in case of object **/
                 return obj;
               }}
               value={locationLabel ? locationLabel : ""}
               errorMessage={"Please select proper label"}
               readOnly={false}
               required={true}
               invalid={false}
               canValidate={canValidate}
               onChange={(value) => {
                 getLocationLabel(value);
               }}
             />
             {/* {field.tooltip && this.getTooltip(field.tooltip)} */}
           </div>
           {/* {field.invalid &&
             this.showPatternError(
               field.validation,
               field.errorMsg,
               field.value
             )} */}
         </div>
       );
     }

     const getManageLocationHeader = () => {
       return (
         <div className="pb-xl">
           <>
             <div className="row p-v-m p-h-m mt-m bg-white border-radius-s shadow-s column">
               {/* <div className="">
                 <DKIcon src={logo} />
                 <DKIcon
                   style={{
                     marginLeft: "-27px",
                   }}
                   src={deskeraBook}
                 />
               </div> */}
               <div className="row pl-l">
                 <Toggle
                   className="mr-s border-n"
                   isOn={trackLocation}
                   onChange={(value) => enableDisableManageLocation(value)}
                 />
                 <span className="mb-xs">Track Locations</span>
                 <div style={{ marginLeft: "auto" }}>
                   {( trackLocation &&
                    // {/* //  <div className="bg-chip-green text-green border-green p-v-s p-h-r border-radius-l fw-m text-wrap-none m-s">
                    // //    Enabled
                    // //  </div> */}
                     <DKButton
                     title="Save"
                     className="border-radius-m text-white bg-app border-m mr-s"
                     onClick={() => {
                       onLocationSettingsSave();
                     }}
                   />
                  )}
                   {!trackLocation && (
                     <div className="bg-white text-gray border-m p-v-s p-h-r border-radius-l fw-m text-wrap-none m-s">
                       Disabled
                     </div>
                   )}
                 </div>
               </div>
               <div className="row pt-m">
                 <div className=" parent-width">
                   {/* <div className="row pt-m"> */}
                   {trackLocation && getLabelField()}
                   {/* {this.state.locationType &&
                       this.getField(
                         "locationType",
                         this.state.locationType,
                         -1,
                         this.state.isDesktop ? "35%" : "100%"
                       )} */}
                   {/* </div> */}
                 </div>
               </div>
               {/* {trackLocation && (<div className="row mt-1 p-h-l">
                   <DKButton
                     title="Save"
                     className="border-radius-m bg-gray1 border-m mr-s"
                     onClick={() => {
                      //  SyncJE();
                     }}
                   />
               </div>)} */}
             </div>
           </>
         </div>
       );
     };

    return (
      <>
        <div className="parent-width flex-1"
        style={{
          pointerEvents: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "":"none",
          opacity: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "1":"0.9"
        }}>
          {/* {getLocationButtons()} */}
          {getManageLocationHeader()}
          {isTrackLocationApiEnabled && (
            <div className="column parent-width mb-s position-relative flex-1">
              <DataGridHolderPayroll
                tableName={TABLES.PEOPLE_LOCATION_LIST}
                displayTableName={
                  TABLE_DISPLAY_NAME[TABLES.PEOPLE_LOCATION_LIST]
                }
                allowColumnEdit={false}
                allowColumnDelete={false}
                allowColumnShift={false}
                allowSearch={false}
                allowFilter={false}
                allowColumnAdd={false}
                onRowDelete={onDeleteLocation}
                onRowEdit={(data) => {
                  onRowEdit(data);
                }}
                //   onCancelContext={() => {
                //     onContextCancel();
                //   }}
                allowRowAdd={true}
                addButtonConfig={[
                  {
                    title: "+ Add Location",
                    className: "bg-app text-white ml-s",
                    onClick: () => onCreateNew(),
                  },
                ]}
                allowDataExport={false}
                gridData={locationsList}
                //   onSearch={onSearch}
                //   onColumnAdd={newColumnAdded}
                //   onFilter={onFilter}
                //   filter={filterArray}
                //   onRowAdd={onRowAdd}
                onPaginationClick={(requestedPageNumber) => {
                  // const config = {
                  //   ...EmployeeListService.apiConfig,
                  //   currentPage: requestedPageNumber,
                  // };
                  loadLocationList();
                }}
                currentPage={currentPage}
                totalPageCount={totalPageCount}
                isActionEnabled={true}
                contextMenu={false}
                isMenuVisible={true}
                allowRowEdit={true}
                showContextEdit={false}
                allowBulkOperation={false}
                onColumnShift={(data)=> setReload(!reload)}
                //   onView={(data) => onView(data)}
              />
            </div>
          )}
        </div>
        {showAddEditPopup && (
          <AddEditLocation
            {...props}
            isEdit={isEdit}
            data={editData}
            onClose={() => onClose()}
          />
        )}
      </>
    );
}

export default ManageLocationList;